import React from 'react';
import styled from 'styled-components';

export interface RatingCursorProps {
  label: string;
  value: number;
}

const Tag = styled.div`
  align-items: center;
  background-color: ${(props) => (props.theme.isDark ? props.theme.palette.darkBlack : '#eef0f4')};
  color: var(--title-foreground);
  border-radius: 6px;
  display: flex;
  padding: 10px 15px;
`;

const Label = styled.div`
  font-family: var(--theme-typography-primary-font);
  font-size: 18px;
  font-weight: 700;
  margin: 0 var(--spacer-xs) 0 0;
`;

const Cursor = styled.div`
  background: white;
  border-radius: 66px;
  margin: 0 15px 0 auto;
  width: 60px;
`;

const CursorValue = styled.div`
  background: var(--theme-palette-green);
  border-radius: 66px;
  height: 10px;

  &.mod-medium {
    background: #f39600;
  }

  &.mod-low {
    background: var(--theme-palette-red);
  }
`;

const Value = styled.span`
  font-family: var(--theme-typography-primary-font);
  font-size: 22px;
  font-weight: 700;
  width: 30px;
`;

export const RatingCursor = ({ ...props }: RatingCursorProps) => {
  const { label, value } = props;
  let modifier = '';

  if (value < 5) {
    modifier = 'mod-low';
  } else if (value < 7) {
    modifier = 'mod-medium';
  }

  return (
    <Tag>
      <Label>{label}</Label>
      <Cursor>
        <CursorValue className={modifier} style={{ width: `${value * 10}%` }} />
      </Cursor>
      <Value>{value}</Value>
    </Tag>
  );
};
